import {
  Building2,
  Home,
  HardHat,
  Droplets,
  Grid2x2,
  Wrench,
  Zap,
  PaintRoller,
  Hammer,
} from "lucide-react";

export const services = [
  {
    icon: Building2,
    title: "Turnkey Construction",
    description:
      "End-to-end construction handled under one system — from foundation to finishing, delivered ready to use.",
  },
  {
    icon: Home,
    title: "Home Renovation",
    description:
      "Transform existing spaces with structured planning, clear scope and dependable execution.",
  },
  {
    icon: HardHat,
    title: "Civil Work",
    description:
      "Reliable structural and civil work carried out with supervised, skilled workmanship.",
  },
  {
    icon: Droplets,
    title: "Waterproofing",
    description:
      "Long-lasting waterproofing for terraces, bathrooms and walls to protect your property.",
  },
  {
    icon: Grid2x2,
    title: "Tiles and Flooring",
    description:
      "Precise tiling and flooring with clean finishes and durable, level surfaces.",
  },
  {
    icon: Wrench,
    title: "Plumbing",
    description:
      "Complete plumbing installation and fixes with neat routing and leak-free fittings.",
  },
  {
    icon: Zap,
    title: "Electrical Work",
    description:
      "Safe, code-conscious electrical wiring, fittings and repairs by coordinated professionals.",
  },
  {
    icon: PaintRoller,
    title: "Painting",
    description:
      "Interior and exterior painting with proper surface prep and a smooth, even coat.",
  },
  {
    icon: Hammer,
    title: "Repair and Maintenance",
    description:
      "Dependable repairs and ongoing maintenance to keep your property in top condition.",
  },
];
